// extracted by mini-css-extract-plugin
export default {"toggle":"ToggleStyles_toggle__b8R+U"};